// @flow

import store from './store'
export { history } from './store'
export default store
